export const feeSettingFormFields = {
   


    feeModel: {
        key: 'feeModel',
        label: 'Fee Model',
        required: true,
        placeholder: '',
        displayLayout: 'col-md-12',
        labelLayout: 'col-sm-12',
        addBreakOptional: false,
        requiredMessage: 'This field is required.',
        tooltip: '<div> Country </div>',
        valueKey: 'id',
        textKey: 'value',

    },

    feeValue: {
        key: 'feeValue',
        type: 'number',
        label: 'Fee Value :',
        required: true,
        placeholder: '',
        requiredMessage: 'This Field is required',
        displayLayout: 'col-sm-12',
        labelLayout: 'col-sm-12',
        addBreakOptional: false,
        min: 1,
        max: 100,
        minLengthMessage: 'Maximum 1 characters allowed.',
        maxLengthMessage: 'Maximum 100 characters allowed.',
        spaceNotAllowed: true,
    },


    strategyName: {
        key: 'strategyName',
        label: 'Select Strategy',
        required: true,
        placeholder: '',
        displayLayout: 'col-md-12',
        labelLayout: 'col-sm-12',
        addBreakOptional: false,
        requiredMessage: 'This field is required.',
        tooltip: '<div> Strategy </div>',
        valueKey: 'id',
        textKey: 'value',

    },
    // Margin Value


    bekiBuyingBidMarginValue: {
        key: 'bekiBuyingBidMarginValue',
        type: 'number',
        label: 'Beki Buying/Bid Value :',
        required: true,
        placeholder: '',
        requiredMessage: 'This Field is required',
        displayLayout: 'col-sm-12',
        labelLayout: 'col-sm-12',
        addBreakOptional: false,
        maxLength: 80,
        maxLengthMessage: 'Maximum 80 characters allowed.',
        spaceNotAllowed: true,
        containsPlatformName: true
    },
    agencyBuyingBidMarginValue: {
        key: 'agencyBuyingBidMarginValue',
        type: 'number',
        label: 'Agency Buying/Bid Value :',
        required: true,
        placeholder: '',
        requiredMessage: 'This Field is required',
        displayLayout: 'col-sm-12',
        labelLayout: 'col-sm-12',
        addBreakOptional: false,
        maxLength: 80,
        maxLengthMessage: 'Maximum 80 characters allowed.',
        spaceNotAllowed: true,
    },
    platformBuyingBidMarginValue: {
        key: 'platformBuyingBidMarginValue',
        type: 'number',
        label: 'Platform Buying/Bid Value :',
        required: true,
        placeholder: '',
        requiredMessage: 'This Field is required',
        displayLayout: 'col-sm-12',
        labelLayout: 'col-sm-12',
        addBreakOptional: false,
        maxLength: 80,
        maxLengthMessage: 'Maximum 80 characters allowed.',
        spaceNotAllowed: true,
    },

    bekiBudgetMarginValue: {
        key: 'bekiBudgetMarginValue',
        type: 'number',
        label: 'Beki Budget Value :',
        required: true,
        placeholder: '',
        requiredMessage: 'This Field is required',
        displayLayout: 'col-sm-12',
        labelLayout: 'col-sm-12',
        addBreakOptional: false,
        maxLength: 80,
        maxLengthMessage: 'Maximum 80 characters allowed.',
        spaceNotAllowed: true,
        containsPlatformName: true
    },
    agencyBudgetMarginValue: {
        key: 'agencyBudgetMarginValue',
        type: 'number',
        label: 'Agency Budget Value :',
        required: true,
        placeholder: '',
        requiredMessage: 'This Field is required',
        displayLayout: 'col-sm-12',
        labelLayout: 'col-sm-12',
        addBreakOptional: false,
        maxLength: 80,
        maxLengthMessage: 'Maximum 80 characters allowed.',
        spaceNotAllowed: true,
    },
    platfromBudgetMarginValue: {
        key: 'platfromBudgetMarginValue',
        type: 'number',
        label: 'Platform Budget Value :',
        required: true,
        placeholder: '',
        requiredMessage: 'This Field is required',
        displayLayout: 'col-sm-12',
        labelLayout: 'col-sm-12',
        addBreakOptional: false,
        maxLength: 80,
        maxLengthMessage: 'Maximum 80 characters allowed.',
        spaceNotAllowed: true,
    },

    // Without margin value

    percentageBekiBuyingBidValue: {
        key: 'percentageBekiBuyingBidValue',
        type: 'number',
        label: 'Beki Buying/Bid Value :',
        required: false,
        placeholder: '',
        requiredMessage: 'This Field is required',
        displayLayout: 'col-sm-12',
        labelLayout: 'col-sm-12',
        addBreakOptional: false,
        maxLength: 80,
        maxLengthMessage: 'Maximum 80 characters allowed.',
        spaceNotAllowed: true,
        containsPlatformName: true
    },

    percentagePlatformBuyingBidValue: {
        key: 'percentagePlatformBuyingBidValue',
        type: 'number',
        label: 'Platform Buying/Bid Value :',
        required: false,
        placeholder: '',
        requiredMessage: 'This Field is required',
        displayLayout: 'col-sm-12',
        labelLayout: 'col-sm-12',
        addBreakOptional: false,
        maxLength: 80,
        maxLengthMessage: 'Maximum 80 characters allowed.',
        spaceNotAllowed: true,
    },

    percentageBekiBudgetValue: {
        key: 'percentageBekiBudgetValue',
        type: 'number',
        label: 'Beki Budget Value :',
        required: false,
        placeholder: '',
        requiredMessage: 'This Field is required',
        displayLayout: 'col-sm-12',
        labelLayout: 'col-sm-12',
        addBreakOptional: false,
        maxLength: 80,
        maxLengthMessage: 'Maximum 80 characters allowed.',
        spaceNotAllowed: true,
        containsPlatformName: true
    },

    percentagePlatfromBudgetValue: {
        key: 'percentagePlatfromBudgetValue',
        type: 'number',
        label: 'Platform Budget Value :',
        required: false,
        placeholder: '',
        requiredMessage: 'This Field is required',
        displayLayout: 'col-sm-12',
        labelLayout: 'col-sm-12',
        addBreakOptional: false,
        maxLength: 80,
        maxLengthMessage: 'Maximum 80 characters allowed.',
        spaceNotAllowed: true,
    },


    // End here

    fixedNewBuyingBidValue: {
        key: 'fixedNewBuyingBidValue',
        type: 'number',
        label: 'New Buying/Bid Value :',
        required: false,
        placeholder: '',
        requiredMessage: 'This Field is required',
        displayLayout: 'col-sm-12',
        labelLayout: 'col-sm-12',
        addBreakOptional: false,
        maxLength: 80,
        maxLengthMessage: 'Maximum 80 characters allowed.',
        spaceNotAllowed: true,
    },

};


export const feeTypeOptionList = [
    { id: '0', value: 'Fixed Value' },
    { id: '1', value: 'Percentage Value' },
]

export const feeModelOptionList = [
    { id: '3', value: 'Advertiser Spend'},
    { id: '0', value: 'CPM' },
    { id: '1', value: 'CPC' },
    { id: '2', value: 'CPA' },
]




